function PlantCard({ plant, onWater, onDelete, onOpenModal }) {


  const today = new Date();
  const lastWateredDate = new Date(plant.lastWatered);
  const diffTime = today - lastWateredDate;
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

  const needsWater = diffDays >= plant.frequencyDays;

  const daysUntilWater = plant.frequencyDays - diffDays;
  let daysInfo;
  if (daysUntilWater > 0) {
    daysInfo = `Water in ${daysUntilWater} day${daysUntilWater === 1 ? "" : "s"}`;
  } else if (daysUntilWater === 0) {
    daysInfo = "Water today!";
  } else {
    daysInfo = `${Math.abs(daysUntilWater)} day${Math.abs(daysUntilWater) === 1 ? "" : "s"} overdue`;
  }

  return (
    <article className={`plant-card ${needsWater ? "needs-water" : "healthy"}`}>
      <div className="plant-card-main" onClick={() => onOpenModal(plant)}>
        <div className="plant-icon-wrapper">
          <span className="plant-icon">{plant.icon}</span>
          {needsWater && <span className="water-indicator">💧</span>}
        </div>

        <div className="plant-info">
          <h3 className="plant-name">{plant.name}</h3>
          <p className="plant-type">{plant.type}</p>
          <p
            className={`plant-status ${needsWater ? "status-alert" : "status-ok"}`}
          >
            {daysInfo}
          </p>
        </div>
      </div>

      <div className="plant-card-actions">
        <button
          className="action-btn water-btn"
          onClick={() => onWater(plant.id)}
        >
          <span>💧</span>
          <span>Water</span>
        </button>

        <button
          className="action-btn delete-btn"
          onClick={() => onDelete(plant.id)}
        >
          <span>🗑️</span>
          <span>Remove</span>
        </button>
      </div>
    </article>
  );
}

export default PlantCard;
